import LinkExternal from '../LinkExternal';
import LinkExternalMulitple from '../LinkExternalMulitple';
import Item from '../Item';

export default [
    {
        component: Item,
        props: {
            render: new LinkExternalMulitple({
                hrefLeft: 'https://cja.ujc.cas.cz/e-cja/',
                hrefRight: 'https://cja.ujc.cas.cz/',
                textMain: 'Český jazykový atlas (ČJA)',
                textLinkLeft: 'nová verze',
                textLinkRight: 'stará verze'
            }),
        },
    },
    {
        component: Item,
        props: {
            render: new LinkExternal({
                href: 'https://sncj.ujc.cas.cz/',
                text: 'Slovník nářečí českého jazyka (SNČJ)',
            }),
        },
    },
    {
        component: Item,
        props: {
            render: new LinkExternal({
                href: 'https://spjc.ujc.cas.cz/',
                text: 'Slovník pomístních jmen v&nbsp;Čechách (SPJČ)',
            }),
        },
    },
    {
        component: Item,
        props: {
            render: new LinkExternal({
                href: 'https://spjms.ujc.cas.cz/',
                text: 'Slovník pomístních jmen na Moravě a ve Slezsku (SPJMS)',
            }),
        },
    },
];